var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 31.1909C5.11667 33.7576 5.11667 26.6076 2 25.6909M24 34.8576V28.4409C24 26.6076 24.1833 25.8742 23.0833 24.7742C28.2167 24.2242 33.1667 22.2076 33.1667 13.7742C33.1644 11.5833 32.3097 9.47931 30.7833 7.90758C31.4992 6.00451 31.4333 3.89556 30.6 2.04091C30.6 2.04091 28.5833 1.49091 24.1833 4.42424C20.4566 3.45365 16.5434 3.45365 12.8167 4.42424C8.41667 1.49091 6.4 2.04091 6.4 2.04091C5.56672 3.89556 5.50081 6.00451 6.21667 7.90758C4.69033 9.47931 3.83557 11.5833 3.83333 13.7742C3.83333 22.2076 8.78333 24.2242 13.9167 24.7742C12.8167 25.8742 12.8167 26.9742 13 28.4409V34.8576",
    stroke: "white",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.76a493ecda1bf603ddc4b73db6fb9b1c.svg";
export { ForwardRef as ReactComponent };